import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {BaseSearchRequest} from './filter-item.model';

@Injectable({
    providedIn: 'root'
})
export class NavigateWithFiltersService {

    private filtersChangeSubject = new Subject<BaseSearchRequest>();
    public filtersChangeTriggered$ = this.filtersChangeSubject.asObservable();

    constructor(private router: Router) {
    }

    /**
     * @param pageName a single route segment, or an array of segments for a nested route
     *                 such as ['business-rules', 'business-rules-priorities'].
     */
    public navigateWithFilters(pageName: string | string[], filters: SimpleNavigationFilters) {
        localStorage.setItem('skipFiltersOnNavigate', 'Y');
        setTimeout(() => {
            this.router.navigate(Array.isArray(pageName) ? pageName : [pageName]);
            setTimeout(this.applyFilters.bind(this, filters), 500);
        }, 100);
    }

    private applyFilters(filters: SimpleNavigationFilters) {
        const newFilters = this.buildSearchRequest(filters);
        this.filtersChangeSubject.next(newFilters);
    }

    private buildSearchRequest(filters: SimpleNavigationFilters): BaseSearchRequest {
        // For multiple 'origin' and 'dest' values, pass as comma separated values.
        const req = new BaseSearchRequest();
        req.rsid = filters.rsid ? [filters.rsid] : null;
        req.origin = filters.origin ? ((filters.origin.indexOf(',') > 0) ? filters.origin.split(',') : [filters.origin]) : null;
        req.destination = filters.dest ? ((filters.dest.indexOf(',') > 0) ? filters.dest.split(',') : [filters.dest]) : null;
        req.startDate = filters.startDate ? filters.startDate : filters.date;
        req.endDate = filters.endDate ? filters.endDate : filters.date;
        req.viewType = filters.viewType;
        req.statusType = filters.statusType;
        req.portfolio = filters.portfolio ? filters.portfolio : null;
        // The business rule prioritization screen requires ruleType and passengerClass;
        // without these the search it fires is rejected by the API (RLP-4261).
        req.ruleType = filters.ruleType;
        req.passengerClass = filters.passengerClass;
        req.journeyType = filters.journeyType ? filters.journeyType : null;
        return req;
    }
}

export class SimpleNavigationFilters {
    public rsid?: string;
    public origin?: string;
    public dest?: string;
    public date?: Date;
    public startDate?: Date;
    public endDate?: Date;
    public viewType?: string;
    public statusType?: string;
    public portfolio?: string[];
    public ruleType?: string;
    public passengerClass?: string;
    public journeyType?: string[];
}
